module.exports = __webpack_public_path__ + "static/media/smart-farm.627409cd.png";